<div class="container">
  <div class="logo-backBtn-container">
    <div class="logo-container">
      <div class="logo">
        <img width="205px" src="../../../../../assets/Primary-dark.svg" alt="e11even logo" />
      </div>
    </div>
  </div>
  <div class="dx-card">
    <div class="dx-card-content">

    <div class="logo-backBtn-container">
      <div class="back-btn-container">
        <div (click)="navBackBtn()" class="back-button">
          <img class="back-arrow-icon" src="../../../../assets//back-arrow.svg" alt="navigate back" />
        </div>
      </div>
    </div>
    <div class="text-container">
      <p class="text-1">LET'S GET YOU SORTED</p>
      <p class="text-2">Identification Check</p>
      <p class="text-3">Please select your country and enter your ID to verify your account</p>
    </div>

    <div *ngIf="staticDataCountries$ | async as staticDataCountries" class="dropdown">
      <div>
        <!-- TO DO -->

      </div>

      <form [formGroup]="formSelect">
        <div class="identification-box">
          <div class="input-container">
            <div class="p-field">
              <span class="p-float-label">
                <input
                  pInputText
                  formControlName="idPassportInput"
                  id="name"
                  class="id-passport"
                  type="text"
                  aria-describedby="name-desc"
                  maxlength="15"
                  minlength="5"
                  (ngModelChange)="validatePassportId($event)"
                  (keyup.enter)="submit()"
                />
                <label for="inputtext">ID/Passport</label>
              </span>
            </div>

            <div *ngIf="validateError$ | async as validateFail">
              <div *ngIf="validateFail !== null">
                <p class="warning-text">Please enter a valid government ID number</p>
              </div>
            </div>
          </div>
        </div>
      </form>
      <div class="button-container">
        <button [disabled]="!formSelect.valid" (click)="submit()" class="sign-in-button">Submit</button>
      </div>
    </div>

    </div>
  </div>
</div>
